import { createListQueryHook } from '@/hooks/lib/createListQueryHook';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys } from '@/lib/queryKeys';
import type { EstimateListParams, EstimateListResponse } from '@/types/estimate';

/**
 * Fetches the paginated list of estimates from the operations microservice.
 */
export const useEstimates = createListQueryHook<EstimateListParams, EstimateListResponse>({
  queryKey: (params) => estimateKeys.list(params),
  endpoint: () => opsEstimateEndpoints.list(),
});
